import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ModalPermissionAccessMeasureComponent } from '../modal-permission-access-measure/modal-permission-access-measure.component';

@Component({
  selector: 'app-modal-select-report',
  templateUrl: './modal-select-report.component.html',
  styleUrls: ['./modal-select-report.component.scss']
})
export class ModalSelectReportComponent implements OnInit {

  modalData: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalSelectReportComponent>,
    public matDialog: MatDialog,
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
  }

  otherReport() {
    const response = {
      status: true,
      value: 'other'
    }

    this.dialogRef.close(response);
  }

  myReport() {
    const response = {
      status: true,
      value: 'myReport'
    }

    this.dialogRef.close(response);
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }

  permission() {
    const dialogPermissionConfig = new MatDialogConfig();
    dialogPermissionConfig.disableClose = true;
    dialogPermissionConfig.id = 'modalPermission';
    dialogPermissionConfig.width = '600px';
    dialogPermissionConfig.height = '315px';
    dialogPermissionConfig.autoFocus = false;
    dialogPermissionConfig.data = {
      MEASURE_ID: this.modalData.MEASURE_ID
    }
    const modal = this.matDialog.open(ModalPermissionAccessMeasureComponent, dialogPermissionConfig);
  }

}
